import { render, staticRenderFns } from "./booklet-template-gallery-editor.vue?vue&type=template&id=14a14f3c"
import script from "./booklet-template-gallery-editor.vue?vue&type=script&lang=ts"
export * from "./booklet-template-gallery-editor.vue?vue&type=script&lang=ts"
import style0 from "./booklet-template-gallery-editor.vue?vue&type=style&index=0&id=14a14f3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports